import { SignUpReasons } from './components/SignUpReasons';
import { SignTabs } from './components/SignTabs';

import styles from './AuthModal.module.scss';
import { AuthModalProps } from './types';

export const AuthModal = ({ onAuthModalClose }: AuthModalProps) => {
	return (
		<div className={styles.authModal__container}>
			<SignUpReasons />
			<SignTabs onAuthModalClose={onAuthModalClose} />
		</div>
	);
};
